export default __webpack_public_path__ + "static/media/Blackfriday_Medico_Banners_330x330.c7796eb5.jpg";